var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "my-page" },
    [
      _c(
        "el-card",
        {
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function() {
                return [
                  _c(
                    "div",
                    [
                      _c("div", { staticClass: "page-title" }, [
                        _c("span", [_vm._v(_vm._s(_vm.PageTitle))])
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        { attrs: { inline: true, size: "small" } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder:
                                      _vm.translateWords.DepartmentName
                                  },
                                  model: {
                                    value: _vm.departmentid,
                                    callback: function($$v) {
                                      _vm.departmentid = $$v
                                    },
                                    expression: "departmentid"
                                  }
                                },
                                _vm._l(_vm.DepartmentDropList, function(item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _c("el-input", {
                                staticStyle: { width: "200px" },
                                attrs: {
                                  placeholder:
                                    _vm.translateWords.inputCommodityName
                                },
                                model: {
                                  value: _vm.spmc,
                                  callback: function($$v) {
                                    _vm.spmc = $$v
                                  },
                                  expression: "spmc"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _c("el-input", {
                                staticStyle: { width: "200px" },
                                attrs: {
                                  placeholder:
                                    _vm.translateWords.commodityBarCode
                                },
                                model: {
                                  value: _vm.spbm,
                                  callback: function($$v) {
                                    _vm.spbm = $$v
                                  },
                                  expression: "spbm"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder:
                                      _vm.translateWords.positionName,
                                    filterable: ""
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.selectvalue(_vm.gsfj)
                                    }
                                  },
                                  model: {
                                    value: _vm.gsfj,
                                    callback: function($$v) {
                                      _vm.gsfj = $$v
                                    },
                                    expression: "gsfj"
                                  }
                                },
                                _vm._l(_vm.gsfjoptions, function(item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    filterable: "",
                                    placeholder:
                                      _vm.translateWords.selectRackLayer
                                  },
                                  model: {
                                    value: _vm.hjh,
                                    callback: function($$v) {
                                      _vm.hjh = $$v
                                    },
                                    expression: "hjh"
                                  }
                                },
                                _vm._l(_vm.hjhoptions, function(item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _vm.env != "unico" &&
                              _vm.type != "aigosampleformarketcenter"
                                ? _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        filterable: "",
                                        placeholder: _vm.translateWords.Source
                                      },
                                      model: {
                                        value: _vm.Source,
                                        callback: function($$v) {
                                          _vm.Source = $$v
                                        },
                                        expression: "Source"
                                      }
                                    },
                                    _vm._l(_vm.Sourceoptions, function(item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      })
                                    }),
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    filterable: "",
                                    placeholder: "是否区分大小写"
                                  },
                                  model: {
                                    value: _vm.IsCaseSensitive,
                                    callback: function($$v) {
                                      _vm.IsCaseSensitive = $$v
                                    },
                                    expression: "IsCaseSensitive"
                                  }
                                },
                                _vm._l(_vm.CaseSensitiveOptions, function(
                                  item
                                ) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _vm.PermissonList.Search.value
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.query }
                                    },
                                    [_vm._v(_vm._s(_vm.translateWords.query))]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          false
                            ? [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "300px" },
                                          attrs: {
                                            placeholder:
                                              _vm.translateWords.gysdm
                                          },
                                          model: {
                                            value: _vm.gysdm,
                                            callback: function($$v) {
                                              _vm.gysdm = $$v
                                            },
                                            expression: "gysdm"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              filterable: "",
                                              placeholder:
                                                _vm.translateWords
                                                  .selectneworold
                                            },
                                            model: {
                                              value: _vm.xjp,
                                              callback: function($$v) {
                                                _vm.xjp = $$v
                                              },
                                              expression: "xjp"
                                            }
                                          },
                                          _vm._l(_vm.xjpoptions, function(
                                            item
                                          ) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label: item.label,
                                                value: item.value
                                              }
                                            })
                                          }),
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              filterable: "",
                                              placeholder:
                                                _vm.translateWords.selectstatus
                                            },
                                            model: {
                                              value: _vm.zt,
                                              callback: function($$v) {
                                                _vm.zt = $$v
                                              },
                                              expression: "zt"
                                            }
                                          },
                                          _vm._l(_vm.ztoptions, function(item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label: item.label,
                                                value: item.value
                                              }
                                            })
                                          }),
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          [
                            _c(
                              "el-form-item",
                              [
                                _vm.PermissonList.InOutSearch.value
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.openrkrecord }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.translateWords.openrkrecord
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _vm.PermissonList.Add.value &&
                                _vm.env != "unico" &&
                                _vm.type != "aigosampleformarketcenter"
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.openaddsampleforagbs }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.translateWords.addSample
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _vm.PermissonList.Add.value &&
                                (_vm.env == "unico" ||
                                  _vm.type == "aigosampleformarketcenter")
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.openaddsample }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.translateWords.addSample
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _vm.PermissonList.BatchAdd.value &&
                                _vm.env == "unico"
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.openaddplsample }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.translateWords.pladdsample)
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _vm.PermissonList.Export.value
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.exprotexcel }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.translateWords.Export)
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _vm.PermissonList.UpLoad.value &&
                                (_vm.env == "unico" ||
                                  _vm.type == "aigosampleformarketcenter")
                                  ? _c(
                                      "el-upload",
                                      {
                                        ref: "upload",
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "",
                                          "file-list": _vm.fileList,
                                          limit: 1,
                                          "before-upload": function(file) {
                                            return _vm.handleUploadBeforeUpload(
                                              file,
                                              "sp"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              slot: "trigger",
                                              type: "primary"
                                            },
                                            slot: "trigger"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.translateWords.loadCommodity
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "el-upload__tip",
                                          attrs: { slot: "tip" },
                                          slot: "tip"
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _vm.PermissonList.UpLoadStock.value
                                  ? _c(
                                      "el-upload",
                                      {
                                        ref: "upload",
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "",
                                          "file-list": _vm.fileList,
                                          limit: 1,
                                          "before-upload": function(file) {
                                            return _vm.handleUploadBeforeUpload(
                                              file,
                                              "pd"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              slot: "trigger",
                                              type: "primary"
                                            },
                                            slot: "trigger"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.translateWords.countStort
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "el-upload__tip",
                                          attrs: { slot: "tip" },
                                          slot: "tip"
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _vm.PermissonList.BatchDelete.value &&
                                _vm.env == "unico"
                                  ? _c(
                                      "el-upload",
                                      {
                                        ref: "upload",
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "",
                                          "file-list": _vm.fileList,
                                          limit: 1,
                                          "before-upload": function(file) {
                                            return _vm.handleUploadBeforeUpload(
                                              file,
                                              "batchdeleteproduct"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              slot: "trigger",
                                              type: "primary"
                                            },
                                            slot: "trigger"
                                          },
                                          [
                                            _vm._v(
                                              "\n                  批量删除样品\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "el-upload__tip",
                                          attrs: { slot: "tip" },
                                          slot: "tip"
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            false ? void 0 : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _vm.PermissonList.BatchDelete.value &&
                                _vm.env == "unico"
                                  ? _c(
                                      "el-upload",
                                      {
                                        ref: "upload",
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "",
                                          "file-list": _vm.fileList,
                                          limit: 1,
                                          "before-upload": function(file) {
                                            return _vm.handleUploadBeforeUpload(
                                              file,
                                              "batchupdateproductposition"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              slot: "trigger",
                                              type: "primary"
                                            },
                                            slot: "trigger"
                                          },
                                          [
                                            _vm._v(
                                              "\n                  批量修改样品位置\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "el-upload__tip",
                                          attrs: { slot: "tip" },
                                          slot: "tip"
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _vm.PermissonList.BatchUpdateStorage.value &&
                                _vm.env == "unico"
                                  ? _c(
                                      "el-upload",
                                      {
                                        ref: "upload",
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "",
                                          "file-list": _vm.fileList,
                                          limit: 1,
                                          "before-upload": function(file) {
                                            return _vm.handleUploadBeforeUpload(
                                              file,
                                              "batchupdatestorage"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              slot: "trigger",
                                              type: "primary"
                                            },
                                            slot: "trigger"
                                          },
                                          [
                                            _vm._v(
                                              "\n                  批量修改样品库存\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "el-upload__tip",
                                          attrs: { slot: "tip" },
                                          slot: "tip"
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _vm.PermissonList.BatchSplitSubCode.value &&
                                _vm.env == "unico"
                                  ? _c(
                                      "el-upload",
                                      {
                                        ref: "upload",
                                        staticClass: "upload-demo",
                                        attrs: {
                                          action: "",
                                          "file-list": _vm.fileList,
                                          limit: 1,
                                          "before-upload": function(file) {
                                            return _vm.handleUploadBeforeUpload(
                                              file,
                                              "batchsplitsubcode"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              slot: "trigger",
                                              type: "primary"
                                            },
                                            slot: "trigger"
                                          },
                                          [
                                            _vm._v(
                                              "\n                  批量拆分样品位置\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "el-upload__tip",
                                          attrs: { slot: "tip" },
                                          slot: "tip"
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _vm.PermissonList.BatchAddStorage.value &&
                                _vm.env == "unico"
                                  ? _c(
                                      "el-upload",
                                      {
                                        ref: "upload",
                                        staticClass: "upload-demo",
                                        attrs: {
                                          "file-list": _vm.fileList,
                                          limit: 1,
                                          "before-upload": function(file) {
                                            return _vm.handleUploadBeforeUpload(
                                              file,
                                              "batchaddstorage"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              slot: "trigger",
                                              type: "primary"
                                            },
                                            slot: "trigger"
                                          },
                                          [
                                            _vm._v(
                                              "\n                  批量入库\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "el-upload__tip",
                                          attrs: { slot: "tip" },
                                          slot: "tip"
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          _vm._v(" "),
                          [
                            _c("el-form-item", [
                              _vm.PermissonList.DownLoadSampleTemplate.value &&
                              _vm.env == "unico"
                                ? _c("a", { attrs: { href: _vm.spmoban } }, [
                                    _vm._v(_vm._s(_vm.translateWords.model))
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.PermissonList.DownLoadStockTemplate.value
                                ? _c("a", { attrs: { href: _vm.kcmoban } }, [
                                    _vm._v(
                                      _vm._s(_vm.translateWords.repertoryModel)
                                    )
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _vm.PermissonList.BatchDelete.value &&
                            _vm.env == "unico"
                              ? _c("el-form-item", [
                                  _c(
                                    "a",
                                    { attrs: { href: _vm.batchdeletemoban } },
                                    [_vm._v("批量删除样品模板")]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.PermissonList.BatchDelete.value &&
                            _vm.env == "unico"
                              ? _c("el-form-item", [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href:
                                          _vm.batchupdateproductpositionmoban
                                      }
                                    },
                                    [_vm._v("批量修改样品位置模板")]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.PermissonList.BatchUpdateStorage.value &&
                            _vm.env == "unico"
                              ? _c("el-form-item", [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.batchupdatestoragemoban
                                      }
                                    },
                                    [_vm._v("批量修改样品库存模板")]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.PermissonList.BatchSplitSubCode.value &&
                            _vm.env == "unico"
                              ? _c("el-form-item", [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.batchsplitsubcodemoban
                                      }
                                    },
                                    [_vm._v("批量拆分样品库存位置模板")]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.PermissonList.SearchCountryCode.value
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content: _vm.countryid,
                                          placement: "top"
                                        }
                                      },
                                      [
                                        _c("el-button", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translateWords
                                                .searchdepartmentid
                                            )
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _vm.env == "unico"
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content: _vm.productremark,
                                          placement: "top"
                                        }
                                      },
                                      [
                                        _c("el-button", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translateWords.productremark
                                            )
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _vm.PermissonList.LangDownLoadSampleTemplate
                                  .value && _vm.env == "unico"
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.modelload }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.translateWords.modeldownload
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _vm.PermissonList.SearchKeyRecord.value
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.doshowkeyrecord }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.translateWords.querykey)
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            false ? void 0 : _vm._e()
                          ]
                        ],
                        2
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.tableData,
                    border: "",
                    "highlight-current-row": "",
                    size: "small",
                    "max-height": "800"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "Id", label: _vm.translateWords.code }
                  }),
                  _vm._v(" "),
                  false
                    ? _c("el-table-column", {
                        attrs: { prop: "Sys_Guid", label: "Sys_Guid" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "ProductName",
                      label: _vm.translateWords.commodityName,
                      width: "240",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "150",
                      prop: "ProductCode",
                      label: _vm.translateWords.commodityBarCode,
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "150",
                      prop: "ProductType",
                      label: _vm.translateWords.commodityClassis,
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _vm.env == "unico" || _vm.type == "aigosampleformarketcenter"
                    ? _c("el-table-column", {
                        attrs: {
                          width: "150",
                          prop: "ModelType",
                          label: _vm.translateWords.ModelType,
                          "show-overflow-tooltip": ""
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  false
                    ? _c("el-table-column", {
                        attrs: {
                          width: "1",
                          prop: "SupplierCode",
                          label: _vm.translateWords.supplierCode
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.env != "unico" && _vm.type != "aigosampleformarketcenter"
                    ? _c("el-table-column", {
                        attrs: {
                          width: "100",
                          prop: "NewOrOld",
                          label: _vm.translateWords.newOrOld,
                          "show-overflow-tooltip": ""
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "SumStorage",
                      label: _vm.translateWords.sumStorage
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "CanBeUseStorage",
                      label: _vm.translateWords.canBeUseStorage
                    }
                  }),
                  _vm._v(" "),
                  _vm.env != "unico" && _vm.type != "aigosampleformarketcenter"
                    ? _c("el-table-column", {
                        attrs: {
                          width: "150",
                          prop: "GoodsCode",
                          label: _vm.translateWords.GoodsCode,
                          "show-overflow-tooltip": ""
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.env != "unico" && _vm.type != "aigosampleformarketcenter"
                    ? _c("el-table-column", {
                        attrs: {
                          width: "100",
                          prop: "Unit",
                          label: _vm.translateWords.Unit,
                          "show-overflow-tooltip": ""
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.env != "unico" && _vm.type != "aigosampleformarketcenter"
                    ? _c("el-table-column", {
                        attrs: {
                          width: "120",
                          prop: "DesignedForName",
                          label: _vm.translateWords.DesignedForName,
                          "show-overflow-tooltip": ""
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.env != "unico" && _vm.type != "aigosampleformarketcenter"
                    ? _c("el-table-column", {
                        attrs: {
                          width: "120",
                          prop: "GoodsSize",
                          label: _vm.translateWords.GoodsSize,
                          "show-overflow-tooltip": ""
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  false
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "IsBig",
                          label: _vm.translateWords.IsBig,
                          width: "1",
                          "show-overflow-tooltip": ""
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  false
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "IsBigStr",
                          label: _vm.translateWords.IsBig,
                          "show-overflow-tooltip": ""
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.env != "unico" && _vm.type != "aigosampleformarketcenter"
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "ImgType",
                          label: _vm.translateWords.ImgType,
                          "show-overflow-tooltip": ""
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  false
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "IsRequestByMultimedia",
                          label: _vm.translateWords.IsRequestByMultimedia,
                          width: "1"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  false
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "IsRequestByMultimediaStr",
                          label: _vm.translateWords.IsRequestByMultimedia
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  false
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "IsRequestByProductCenter",
                          label: _vm.translateWords.IsRequestByProductCenter,
                          width: "1"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  false
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "IsRequestByProductCenterStr",
                          label: _vm.translateWords.IsRequestByProductCenter
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  false
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "ExpectedShipmentDateTime",
                          label: _vm.translateWords.ExpectedShipmentDateTime
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.env != "unico" && _vm.type != "aigosampleformarketcenter"
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "ExpectedShipmentDateTimeStr",
                          label: _vm.translateWords.ExpectedShipmentDateTime,
                          width: "150",
                          "show-overflow-tooltip": ""
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  false
                    ? _c("el-table-column", {
                        attrs: {
                          width: "1",
                          prop: "PositionId",
                          label: _vm.translateWords.positionId
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  false
                    ? _c("el-table-column", {
                        attrs: {
                          width: "1",
                          prop: "RackId",
                          label: _vm.translateWords.rackId
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "RackNo",
                      label: _vm.translateWords.rackNo,
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "DepartMentName",
                      label: _vm.translateWords.gsgj,
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "PositionName",
                      label: _vm.translateWords.positionName,
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "100",
                      prop: "Status",
                      label: _vm.translateWords.status,
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "Remark",
                      label: _vm.translateWords.remark,
                      width: "200",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  false
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "ProductTypeCode",
                          label: _vm.translateWords.remark,
                          width: "1"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  false
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "StatusCode",
                          label: _vm.translateWords.remark,
                          width: "1"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.translateWords.operate,
                      width: "280",
                      fixed: "right"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm.PermissonList.ChangeLog.value
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleChangeLog(scope.row)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.translateWords.SampleChangeLog)
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.PermissonList.Update.value
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleEdit(
                                          scope.$index,
                                          scope.row
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.translateWords.edit))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.PermissonList.PutInStorage.value
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.handlerk(
                                          scope.$index,
                                          scope.row
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.translateWords.scope))]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("el-pagination", {
                staticStyle: { margin: "1em 0" },
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "page-sizes": [10, 20, 50, 100, 200],
                  "current-page": _vm.currPage,
                  "page-size": _vm.pageSize,
                  total: _vm.total
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisibleEditFromAGBS,
            width: "70%",
            "show-close": true
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisibleEditFromAGBS = $event
            }
          }
        },
        [
          _c("EditSampleFromAGBS", {
            ref: "EditSampleFromAGBS",
            attrs: { PositionIdoptions: _vm.gsfjoptions, title: _vm.title },
            on: { closedialogFromAGBS: _vm.closedialogFromAGBS }
          }),
          _vm._v(" "),
          _c("span", {
            staticClass: "dialog-footer",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "70%",
            "show-close": true
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("AddSample", {
            ref: "AddSample",
            attrs: { PositionIdoptions: _vm.gsfjoptions, title: _vm.title },
            on: { closedialog: _vm.closedialog }
          }),
          _vm._v(" "),
          _c("span", {
            staticClass: "dialog-footer",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisiblepladdsample,
            width: "90%",
            "show-close": true
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisiblepladdsample = $event
            }
          }
        },
        [
          _c("WP", { ref: "WP", attrs: { guishufangjian: _vm.gsfjoptions } }),
          _vm._v(" "),
          _c("span", {
            staticClass: "dialog-footer",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisiblerk,
            width: "40%",
            "show-close": true
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisiblerk = $event
            }
          }
        },
        [
          _c("RK", { ref: "RK", on: { closedialogrk: _vm.closedialogrk } }),
          _vm._v(" "),
          _c("span", {
            staticClass: "dialog-footer",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisiblerkjl,
            width: "90%",
            "show-close": true
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisiblerkjl = $event
            }
          }
        },
        [
          _c("RKRecord", { ref: "RKRecord" }),
          _vm._v(" "),
          _c("span", {
            staticClass: "dialog-footer",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisiblekeyrecord,
            width: "90%",
            "show-close": true
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisiblekeyrecord = $event
            }
          }
        },
        [
          _c("SampleKeyRecord", { ref: "SampleKeyRecord" }),
          _vm._v(" "),
          _c("span", {
            staticClass: "dialog-footer",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisibleAddSampleFromAGBS,
            width: "90%",
            "show-close": true,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisibleAddSampleFromAGBS = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.SelectBar()
                    }
                  }
                },
                [_vm._v("选中条码")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c("el-input", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false"
                  }
                ],
                staticStyle: { width: "200px" },
                model: {
                  value: _vm.docusername,
                  callback: function($$v) {
                    _vm.docusername = $$v
                  },
                  expression: "docusername"
                }
              }),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  ref: "temptableData",
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.temptableData }
                },
                [
                  false
                    ? _c("el-table-column", {
                        attrs: { prop: "Goods_Id", label: "Id", width: "1" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "Goods_Name2",
                      label: _vm.translateWords.ProductName,
                      width: "200"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "BarCode",
                      label: _vm.translateWords.ProductCode
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "Goods_BigClass",
                      label: _vm.translateWords.ProductType
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "Goods_Code",
                      label: _vm.translateWords.GoodsCode
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "DesignedForName",
                      label: _vm.translateWords.DesignedForName
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "Goods_Size1",
                      label: _vm.translateWords.GoodsSize
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "Unit",
                      label: _vm.translateWords.Unit
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "IsBig",
                      label: _vm.translateWords.IsBig
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-select",
                              {
                                model: {
                                  value: scope.row.IsBig,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "IsBig", $$v)
                                  },
                                  expression: "scope.row.IsBig"
                                }
                              },
                              _vm._l(_vm.Options.IsBig, function(el) {
                                return _c("el-option", {
                                  key: String(el.Code),
                                  attrs: {
                                    label: el.Name,
                                    value: String(el.Code)
                                  }
                                })
                              }),
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "ImgType",
                      label: _vm.translateWords.ImgType
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-select",
                              {
                                model: {
                                  value: scope.row.ImgType,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "ImgType", $$v)
                                  },
                                  expression: "scope.row.ImgType"
                                }
                              },
                              _vm._l(_vm.Options.ImgType, function(el) {
                                return _c("el-option", {
                                  key: String(el.Code),
                                  attrs: {
                                    label: el.Name,
                                    value: String(el.Code)
                                  }
                                })
                              }),
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "IsRequestByProductCenter",
                      label: _vm.translateWords.IsRequestByProductCenter
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-select",
                              {
                                model: {
                                  value: scope.row.IsRequestByProductCenter,
                                  callback: function($$v) {
                                    _vm.$set(
                                      scope.row,
                                      "IsRequestByProductCenter",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "scope.row.IsRequestByProductCenter"
                                }
                              },
                              _vm._l(_vm.Options.IsOrNot, function(el) {
                                return _c("el-option", {
                                  key: String(el.Code),
                                  attrs: {
                                    label: el.Name,
                                    value: String(el.Code)
                                  }
                                })
                              }),
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "IsRequestByMultimedia",
                      label: _vm.translateWords.IsRequestByMultimedia
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-select",
                              {
                                model: {
                                  value: scope.row.IsRequestByMultimedia,
                                  callback: function($$v) {
                                    _vm.$set(
                                      scope.row,
                                      "IsRequestByMultimedia",
                                      $$v
                                    )
                                  },
                                  expression: "scope.row.IsRequestByMultimedia"
                                }
                              },
                              _vm._l(_vm.Options.IsOrNot, function(el) {
                                return _c("el-option", {
                                  key: String(el.Code),
                                  attrs: {
                                    label: el.Name,
                                    value: String(el.Code)
                                  }
                                })
                              }),
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "ExpectedShipmentDateTime",
                      label: _vm.translateWords.ExpectedShipmentDateTime
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-date-picker", {
                              attrs: {
                                format: "yyyy-MM-dd",
                                type: "date",
                                placeholder: "选择日期"
                              },
                              model: {
                                value: scope.row.ExpectedShipmentDateTime,
                                callback: function($$v) {
                                  _vm.$set(
                                    scope.row,
                                    "ExpectedShipmentDateTime",
                                    $$v
                                  )
                                },
                                expression: "scope.row.ExpectedShipmentDateTime"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "ExpectedArrivalDateTime",
                      label: _vm.translateWords.ExpectedArrivalDateTime
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-date-picker", {
                              attrs: {
                                format: "yyyy-MM-dd",
                                type: "date",
                                placeholder: "选择日期"
                              },
                              model: {
                                value: scope.row.ExpectedArrivalDateTime,
                                callback: function($$v) {
                                  _vm.$set(
                                    scope.row,
                                    "ExpectedArrivalDateTime",
                                    $$v
                                  )
                                },
                                expression: "scope.row.ExpectedArrivalDateTime"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "SumStorage",
                      label: _vm.translateWords.SumStorage
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-input", {
                              model: {
                                value: scope.row.SumStorage,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "SumStorage", _vm._n($$v))
                                },
                                expression: "scope.row.SumStorage"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "PositionId",
                      label: _vm.translateWords.positionName
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: _vm.translateWords.positionName,
                                  filterable: ""
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.selectvaluefortable(scope.row)
                                  }
                                },
                                model: {
                                  value: scope.row.PositionId,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "PositionId", $$v)
                                  },
                                  expression: "scope.row.PositionId"
                                }
                              },
                              _vm._l(_vm.gsfjoptions, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: String(item.value)
                                  }
                                })
                              }),
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "RackId",
                      label: _vm.translateWords.hjh
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder:
                                    _vm.translateWords.selectRackLayer,
                                  filterable: ""
                                },
                                model: {
                                  value: scope.row.RackId,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "RackId", $$v)
                                  },
                                  expression: "scope.row.RackId"
                                }
                              },
                              _vm._l(scope.row.RackList, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: String(item.value)
                                  }
                                })
                              }),
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "Status",
                      label: _vm.translateWords.Status
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-select",
                              {
                                model: {
                                  value: scope.row.Status,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "Status", $$v)
                                  },
                                  expression: "scope.row.Status"
                                }
                              },
                              _vm._l(_vm.Options.Status, function(el) {
                                return _c("el-option", {
                                  key: String(el.Code),
                                  attrs: {
                                    label: el.Name,
                                    value: String(el.Code)
                                  }
                                })
                              }),
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _vm.env != "unico" && _vm.type != "aigosampleformarketcenter"
                    ? _c("el-table-column", {
                        attrs: {
                          width: "200",
                          prop: "NewOrOld",
                          label: _vm.translateWords.newOrOld
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        disabled: scope.row.IsDisabledNewOrOld
                                      },
                                      model: {
                                        value: scope.row.NewOrOld,
                                        callback: function($$v) {
                                          _vm.$set(scope.row, "NewOrOld", $$v)
                                        },
                                        expression: "scope.row.NewOrOld"
                                      }
                                    },
                                    _vm._l(_vm.Options.NewOrOld, function(el) {
                                      return _c("el-option", {
                                        key: String(el.Code),
                                        attrs: {
                                          label: el.Name,
                                          value: String(el.Code)
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1535239003
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "DocUserName",
                      label: _vm.translateWords.docusername
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-input", {
                              model: {
                                value: scope.row.DocUserName,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "DocUserName", $$v)
                                },
                                expression: "scope.row.DocUserName"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "Remark",
                      label: _vm.translateWords.remark
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-input", {
                              model: {
                                value: scope.row.Remark,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "Remark", $$v)
                                },
                                expression: "scope.row.Remark"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: _vm.translateWords.operate, width: "300" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.rowdelete(scope.row)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.translateWords.Delete))]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("el-row"),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 2 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.AddSampleFromAGBS()
                        }
                      }
                    },
                    [_vm._v("提交")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 2 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.ExportFromAGBS()
                        }
                      }
                    },
                    [_vm._v("导出")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 2 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.downloadmodel()
                        }
                      }
                    },
                    [_vm._v("导入模板下载")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 2 } },
                [
                  _vm.PermissonList.UpLoad.value
                    ? _c(
                        "el-upload",
                        {
                          ref: "upload",
                          staticClass: "upload-demo",
                          attrs: {
                            action: "",
                            "file-list": _vm.fileList,
                            limit: 1,
                            "before-upload": _vm.beforeUploadfromagbs
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { slot: "trigger", type: "primary" },
                              slot: "trigger"
                            },
                            [_vm._v("导入")]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "el-upload__tip",
                            attrs: { slot: "tip" },
                            slot: "tip"
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisibleShowGetSampleFromAGBS,
            width: "95%",
            "show-close": true,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisibleShowGetSampleFromAGBS = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c("GetSampleFromAGBS", {
                ref: "GetSampleFromAGBS",
                on: {
                  loadtable: _vm.loadtable,
                  closedialogAGBS: _vm.closedialogAGBS
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisiblemodeload,
            width: "30%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisiblemodeload = $event
            }
          }
        },
        [
          _c("table", [
            _c("tr", [
              _c("td", [
                _c("div", [
                  _c("a", { attrs: { href: _vm.cnspmoban } }, [
                    _vm._v("中文-导入商品新模板")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [
                _c("div", [
                  _c("a", { attrs: { href: _vm.itspmoban } }, [
                    _vm._v("Italian-Importa un nuovo modello di prodotto")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [
                _c("div", [
                  _c("a", { attrs: { href: _vm.spainspmoban } }, [
                    _vm._v("Spanish-Importar una nueva plantilla de productos")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [
                _c("div", [
                  _c("a", { attrs: { href: _vm.enspmoban } }, [
                    _vm._v("English-Import a new product template")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [
                _c("div", [
                  _c("a", { attrs: { href: _vm.nlspmoban } }, [
                    _vm._v("Dutch-Een nieuw productsjabloon importeren")
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogVisiblemodeload = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.translateWords.closediag))]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisibleShowSampleChangeLog,
            width: "75%"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisibleShowSampleChangeLog = $event
            }
          }
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _c("span", { staticClass: "dialog-title" }, [
              _vm._v(_vm._s(_vm.translateWords.SampleChangeLog))
            ])
          ]),
          _vm._v(" "),
          _vm.dialogVisibleShowSampleChangeLog
            ? _c("SampleChangeLog", { attrs: { rowModel: _vm.currRowModel } })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16f1924c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16f1924c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sample.vue
// module id = null
// module chunks = 